// Provider -> adapter. The only place a provider name is switched on; every
// other decision is made by asking the adapter what it can do.

import { createMockAdapter } from './adapters/mock';
import { createSsmAdapter } from './adapters/ssm';
import type { PmsTransport } from './transport';
import type { PmsAdapter, PmsOp, PmsProvider } from './types';

export interface RegistryDeps {
  transport: PmsTransport;
}

/** Returns null for a facility with no integration ('none') or an unbuilt one. */
export function getAdapter(provider: PmsProvider, deps: RegistryDeps): PmsAdapter | null {
  switch (provider) {
    case 'ssm':
      return createSsmAdapter({ transport: deps.transport });
    case 'mock':
      return createMockAdapter();
    case 'sitelink': // ported in a later phase — the proof the seam holds
    case 'none':
    default:
      return null;
  }
}

export function supports(adapter: PmsAdapter | null, op: PmsOp): boolean {
  if (!adapter) return false;
  if (!adapter.capabilities.has(op)) return false;
  // A capability must come with an implementation.
  return typeof (adapter as unknown as Record<string, unknown>)[op] === 'function';
}
